import React, { useState, useEffect } from "react";
import { api } from "../../../api/apiUtils";
import { getPhotos, getNearestFreeTime } from "../../../constants.json";
import LoadingComponent from "../OnlineRecord/LoadingComponent/LoadingComponent";
import "./SharePage.scss";
import _ from "lodash";
const Swal = require('../../../scripts/sweetalert.min.js');

const SharePage = () => {
  const [doctors, setDoctors] = useState([]);


  useEffect(() => {
    api({
      method: "GET",
      url: `api/Doctor/GetVisibleDoctors`,
      params: {
        isShowInSchedule: true,
        isShowPhoto: getPhotos,
        isAddNearestFreeTime: getNearestFreeTime,
      },
    }).then((data) => {
      setDoctors(data);
    });
  }, []);

  function copyToClipboard(textToCopy) {
    if (navigator.clipboard && window.isSecureContext) {
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Скопировано в буфер обмена",
        showConfirmButton: false,
        timer: 1000,
      });
      return navigator.clipboard.writeText(textToCopy);
    } else {
      let textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        document.execCommand("copy") ? res() : rej();
        textArea.remove();
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Скопировано в буфер обмена",
          showConfirmButton: false,
          timer: 1000,
        });
      });
    }
  }

  const filtredSpecialities = _.uniqWith(
    doctors.reduce((acc, rec) => {
      return [
        ...acc,
        {
          SpecialityName: rec.SpecialityName,
          IdSpeciality: rec.IdSpeciality,
        },
      ];
    }, []),
    _.isEqual,
  );

  return doctors.length > 0 ? (
    <div>
      <div className={"doctors__links-block"}>
        <div className={"doctors__links-title"}>
          Ссылки чтобы поделиться врачами (Нажмите чтобы скопировать)
        </div>

        {doctors.map((el, idx) => (
          <div className={"doctors__links-link"} key={idx}>
            <div>
              {el.Name} - ({el.SpecialityName})
            </div>
            <div
              className={"doctors__links-link-href"}
              onClick={() =>
                copyToClipboard(
                  `${window.location.origin}/?doctorId="${el.Id}"`,
                )
              }
            >
              {`${window.location.origin}/?doctorId="${el.Id}"`}
            </div>
          </div>
        ))}
      </div>
      <div className={"doctors__links-block"}>
        <div className={"doctors__links-title"}>
          Ссылки чтобы поделиться специальностями (Нажмите чтобы скопировать)
        </div>
        {filtredSpecialities.map((el, idx) => (
          <div className={"doctors__links-link"} key={idx}>
            <div>{el.SpecialityName}</div>
            <div
              className={"doctors__links-link-href"}
              onClick={() =>
                copyToClipboard(
                  `${window.location.origin}/?specialityId="${el.IdSpeciality}"`,
                )
              }
            >{`${window.location.origin}/?specialityId="${el.IdSpeciality}"`}</div>
          </div>
        ))}
      </div>
    </div>
  ) : (
    <LoadingComponent />
  );
};

export default SharePage;
